import moment from 'moment';

  ///---Parameters to send in POST request--///

export const request = {    
    ipark_in : {
        vers:"",
        ah:"",            
        lang:"",
        appvers:"3.0.7",
        WIFIMAC:"",
        IMEI:"",
        cosvers:"1.0",
        OSID:"5",
        cmodel:"IntegraAPI",
        utc_offset:moment().utcOffset(120).format('HHmmssDDMMYYYY'),
        utc_date:moment.utc().format('HHmmssDDMMYYYY'),
        date:moment().format('HHmmssDDMMYYYY'),
        u:'',
        pasw:'',
        cityID:"",
        keepsessionalive:"1",
        InsVersion:"361",
        InsGeomVersion:"3588",
    },
}

